module.exports = __webpack_public_path__ + "img/4.14323fb6.jpg";